<div class="w-full flex flex-col gap-7">
  <div class="w-full text-center">
    <span class="text-qaroni-text-primary font-medium text-lg leading-7"
      >Perfil</span
    >
  </div>

  <div class="w-full grid place-content-center relative group">
    <img
      [src]="image ? image : ImagesConfig.avatar.src"
      [alt]="ImagesConfig.avatar.alt"
      class="w-[80px] h-[80px] rounded-full mx-auto" />
    <div
      class="absolute top-[40px] left-1/2 transform -translate-x-1/2 w-[80px] h-[40px] bg-black bg-opacity-50 rounded-b-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
      <button
        class="text-white py-1 px-3 outline-none"
        [matMenuTriggerFor]="menu">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item class="!mr-2" (click)="file.click()">
    <mat-icon class="material-symbols-outlined">edit</mat-icon>
    <span>Cambiar imagen</span>
  </button>
  @if (image !== null) {
    <button mat-menu-item class="!mr-2" (click)="onDelete()">
      <mat-icon class="material-symbols-outlined">delete</mat-icon>
      <span>Eliminar imagen</span>
    </button>
  }
</mat-menu>

<input
  type="file"
  id="file"
  #file
  name="file"
  class="hidden"
  accept=".jpg,.png,.jpeg,.svg,.webp"
  (change)="onDropFile($event)" />
